import { Col, Button, Row, Typography, Space, Card, Result, message } from "antd";
import dayjs from 'dayjs';
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { HeartOutlined, ShareAltOutlined, FrownOutlined } from '@ant-design/icons';

const NoPermission = ({
    path = null
}) => {
    const { news_id } = useParams()
    const navigate = useNavigate();

    function copyText() {
        let newHerf = window.location.href;
        navigator.clipboard.writeText(newHerf)
            .then(() => {
                message.success("網址複製成功")
            });
    }
    useEffect(() => {

    }, [])

    return (
        <Row
            justify={"center"}
            gutter={[32, 32]}
            style={{
                height: '100vh'
            }}
            align={"middle"}
        >
            <Col xxl={22} xl={22} lg={22} md={22} sm={24} xs={24}>
                <Result
                    icon={<FrownOutlined />}
                    title="很抱歉 您沒有造訪此介面的權限"
                    extra={<Button type="primary"
                        onClick={() => {
                            path ?
                                navigate(path) :
                                window.history.back()
                        }}>
                        返回首頁
                    </Button>}
                />
            </Col>
        </Row>
    )
}
export default NoPermission